<template>
  <b-modal size="xl" class="modal" title="Balance"  v-model="localVisible" hide-footer @hide="closeModal" >
    <b-table :fields="fields" :items="items">

    </b-table>
  </b-modal>
</template>


<script >
import Table from "@/components/Common/Table.vue";
import {CurrencyAmountFormat} from "@core/utils/CurrencyAmountFormat";

export default {
  name:'BalanceModal',
  components: {Table},
  props:{
    isVisible:Boolean,
    data:Object,
  },
  data(){
    return{
      localVisible:this.isVisible,
      items:[],
      currencies:[],
      fields: [
        { key: "currency", label: "Currency" },
        { key: "saldo", label: "Saldo Amount" },
        { key: "amount", label: "Investment Amount" },
        { key: "expecting", label: "Outstanding Expected Net Return" },
      ],
    }
  },
  watch:{
    isVisible(val){this.localVisible =val}
  },

  methods:{
    closeModal(){
      this.localVisible = false;
      this.$emit('update:isVisible', false)
    },
    amountFormat(amount, currency) {
      return CurrencyAmountFormat(amount, currency)
    },
    setTableData() {
      this.$http.post(`buyer/admin/balance/${this.data.id}`).then((response) => {
        if (response.status == 200) {
          response.data.value.map((item) => {
            this.items.push({
              currency:item.currency,
              saldo: this.amountFormat(item.saldo,item.currency) ,
              amount:this.amountFormat(item.invested_amount,item.currency),
              expecting:this.amountFormat(item.outstanding_expected_net_return,item.currency),
            })
          })

        }
      });
    },
  },
  created() {
    this.setTableData()
  },

}
</script>

<style scoped>

</style>